import React, { useEffect, useRef, useState } from "react";
import { Image } from "react-bootstrap";
import { BsChevronDown } from "react-icons/bs";
import { IoIosClose } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import OrderPickingIcon from "../../assets/icons/OrderPicking.svg";
import plusBorderWhite from "../../assets/icons/Plus-border-white.svg";
import Downarrow from "../../assets/icons/downarrow.svg";
import Package from "../../assets/icons/package.svg";
import productIconOrder from "../../assets/icons/product-icon-order.svg";
import projectIconOrder from "../../assets/icons/productIconOrder.svg";
import quoteIconOrder from "../../assets/icons/quote-icon-order.svg";
import searchIcon from "../../assets/icons/search.svg";
import DelIcon from "../../assets/icons/DeleteIconCircle.svg";
import Header from "../../layouts/Header";
import {
  CreateOrderPicking,
  ProductProjectDropdown,
  ProjectDropdown,
  FetchPOByProject,
} from "../../redux/actions/action";
import "../../assets/styles/local/OrderPicking.css";
import { handleGeneralNotification } from "../../utils/helpers/notifications";
import useScreenSize from "../../utils/hooks/useScreenSizeHook";
import { CREATE_ORDER_PICKING } from "../../redux/constants/type";
import RouteLeavingGuard from "../../components/Common/RouteLeavingGuard";
import CancelWarningModal from "../../components/Dailogs/CancelWarningModal";
import { getScreenTranslations } from "../../utils/helpers/translations";

const OrderPickingPOMobile = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const projectDropRef = useRef(null);
  const purchaseOrderDropRef = useRef(null);
  const productDropRef = useRef(null);
  const quoteDropRef = useRef(null);
  const projectId2 = location.state?.projectId;

  const fetchProjectDropdownData = useSelector(
    (state) => state.user.fetchProjectDropdown,
  );
  const fetchProductDropdownData = useSelector(
    (state) => state.user.fetchProductDropdown,
  );
  const fetchCreateOrderPicking = useSelector(
    (state) => state.user.createOrderPicking,
  );
  const fetchPOByProjectResponse = useSelector(
    (state) => state.user.fetchPOByProjectResponse,
  );
  const [FetchTranslationList, setFetchTranslationList] = useState([]);

  const [single, setSingle] = useState(true);
  const [list, setList] = useState(false);
  const [typeField, setTypeField] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [query, setQuery] = useState("");
  const [showClientDrop, setShowClientDrop] = useState(false);
  const [showPurchaseOrderDrop, setShowPurchaseOrderDrop] = useState(false);
  const [showProductDrop, setShowProductDrop] = useState(false);
  const [showQuoteDrop, setShowQuoteDrop] = useState(false);
  const [projectId, setProjectId] = useState("");

  const [projectTableData, setProjectTableData] = useState([]);
  const [selectedProject, setsSelectedProject] = useState(null);
  const [projectSearch, setProjectSearch] = useState("");

  const [purchaseOrderData, setPurchaseOrderData] = useState([]);
  const [selectedPurchaseOrder, setSelectedPurchaseOrder] = useState(null);
  const [purchaseOrderId, setPurchaseOrderId] = useState(null);
  const [purchaseSupplierId, setPurchaseSupplierId] = useState(null);
  const [purchaseOrderSearch, setPurchaseOrderSearch] = useState("");

  const [productTableData, setProductTableData] = useState([]);
  const [productBottomTableData, setProductBottomTableData] = useState({});
  const [selectedProduct, setsSelectedProduct] = useState(null);
  const [searchItems, setSearchItems] = useState("");
  const [productId, setProductId] = useState("");
  const [showProductBottomList, setShowProductBottomList] = useState(false);
  const myAppName = localStorage.getItem("myAppName");
  const isOrderPicking = myAppName === "orderpicking";

  const [selectedQuote, setsSelectedQuote] = useState(null);
  const [coverImage, setCoverImage] = useState("");
  const [isBuildingBlock, setIsBuildingBlock] = useState(false);
  const getAppSideNavOptions = useSelector(
    (state) => state.user.appSideNavOptions,
  );
  useEffect(() => {
    if (getAppSideNavOptions && getAppSideNavOptions.length > 0) {
      setIsBuildingBlock(
        getAppSideNavOptions.some(
          (x) => x.packageId === process.env.REACT_APP_IS_PREMIUM,
        ),
      );
    }
  }, [getAppSideNavOptions]);

  const [showOrderNotification, setShowOrderNotification] = useState(false);

  useEffect(() => {
    // dispatch(ProjectDropdown());
    dispatch(
      FetchPOByProject(
        projectId2,
        "Purchasing",
        // pageNumber,
        // itemsPerPage,
      ),
    );
    getScreenTranslations("Order Picking").then((data) =>
      setFetchTranslationList(data),
    );
  }, []);

  useEffect(() => {
    if (projectId) {
      dispatch(ProductProjectDropdown(projectId));
    }
  }, [dispatch, projectId]);

  useEffect(() => {
    if (fetchProjectDropdownData != null) {
      if (fetchProjectDropdownData?.status) {
        // setProjectTableData(fetchProjectDropdownData?.data);
      }
    }
  }, [fetchProjectDropdownData]);

  useEffect(() => {
    if (fetchPOByProjectResponse != null) {
      if (fetchPOByProjectResponse?.status) {
        setProjectTableData(fetchPOByProjectResponse?.data);
      }
    }
  }, [fetchPOByProjectResponse]);

  useEffect(() => {
    if (fetchPOByProjectResponse != null) {
      if (fetchPOByProjectResponse?.status) {
        setPurchaseOrderData(fetchPOByProjectResponse?.data);
      }
    }
  }, [fetchPOByProjectResponse]);

  useEffect(() => {
    if (fetchProductDropdownData != null) {
      if (fetchProductDropdownData?.status) {
        setProductTableData(fetchProductDropdownData?.data);
      }
    }
  }, [fetchProductDropdownData]);

  useEffect(() => {
    if (fetchCreateOrderPicking != null) {
      if (fetchCreateOrderPicking?.status) {
        setsSelectedProject(null);
        setProjectId("");
        setsSelectedProduct(null);
        setsSelectedQuote(null);
        setShowOrderNotification(true);
        setShowProductBottomList(false);
        dispatch({
          type: CREATE_ORDER_PICKING,
          data: {},
        });
        setCoverImage("");
        setProductTableData([]);
        setProductBottomTableData({});
        setProductId("");
        if (screenSize !== "xs" && !isOrderPicking) {
          handleGeneralNotification({
            notificationType: "CUSTOM",
            text: `Great Job! The product was picked for the project.`,
          });
        }
      }
    }
  }, [fetchCreateOrderPicking]);

  useEffect(() => {
    if (projectSearch) {
      let list = [...fetchProjectDropdownData?.data];
      list = list.filter((client) => {
        return (
          client?.projectname
            ?.toLowerCase()
            ?.startsWith(projectSearch.toLowerCase()) ||
          client?.projectcode
            ?.toLowerCase()
            ?.startsWith(projectSearch.toLowerCase())
        );
      });
      setProjectTableData(list);
    } else {
      setProjectTableData(fetchProjectDropdownData?.data);
    }
  }, [projectSearch]);

  useEffect(() => {
    if (purchaseOrderSearch) {
      let list = [...fetchPOByProjectResponse?.data];
      list = list.filter((poItem) => {
        return (
          poItem?.suppliername
            ?.toLowerCase()
            ?.startsWith(purchaseOrderSearch.toLowerCase()) ||
          poItem?.ordercode
            ?.toLowerCase()
            ?.startsWith(purchaseOrderSearch.toLowerCase())
        );
      });
      setPurchaseOrderData(list);
    } else {
      setPurchaseOrderData(fetchPOByProjectResponse?.data);
    }
  }, [purchaseOrderSearch]);

  useEffect(() => {
    if (searchItems) {
      if (fetchPOByProjectResponse != null) {
        if (fetchPOByProjectResponse?.status) {
          const dataToSet = productTableData?.filter((name) =>
            name.suppliername.toLowerCase().includes(searchItems.toLowerCase()),
          );
          setProductTableData(dataToSet);
        }
      }
    } else {
      setProductTableData(fetchPOByProjectResponse?.data);
    }
  }, [searchItems]);

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (
      projectDropRef.current &&
      !projectDropRef.current.contains(event.target)
    ) {
      setShowClientDrop(false);
    }
    if (
      purchaseOrderDropRef.current &&
      !purchaseOrderDropRef.current.contains(event.target)
    ) {
      setShowPurchaseOrderDrop(false);
    }
    if (
      productDropRef.current &&
      !productDropRef.current.contains(event.target)
    ) {
      setShowProductDrop(false);
    }
    if (quoteDropRef.current && !quoteDropRef.current.contains(event.target)) {
      setShowQuoteDrop(false);
    }
  };

  const handleSelectedProduct = (items) => {
    const updatedData = {
      ...items,
      qtyToPick: items.qtyToPick,
      newQtyToPick: items.qtyToPick,
    };
    setProductBottomTableData(updatedData);
    setsSelectedProduct(items.productPartName);
    setShowProductDrop(false);
    setProductId(items.productPartid);
    setShowProductBottomList(true);
    setCoverImage(items.cover);
  };

  const handleInputChange = (e) => {
    e.preventDefault();
    const { value } = e.target;
    const newValue = Number(value);
    setProductBottomTableData({
      ...productBottomTableData,
      newQtyToPick: newValue,
    });
  };

  const HandleAddPickingOrder = () => {
    if (
      productBottomTableData?.newQtyToPick > productBottomTableData?.instock ||
      productBottomTableData?.newQtyToPick >
        productBottomTableData?.qtyToPick ||
      productBottomTableData?.qtyToPick === 0 ||
      productBottomTableData?.newQtyToPick === 0 ||
      productBottomTableData?.instock === 0
    ) {
      if (screenSize !== "xs") {
        handleGeneralNotification({
          notificationType: "CUSTOM",
          text: `please adjust qty to pick according to a stock.`,
        });
      }
      return;
    }
    setTypeField("");
    const orderProductQty = [
      {
        orderproductqty: productBottomTableData.newQtyToPick,
      },
    ];
    dispatch(CreateOrderPicking("", productId, projectId, orderProductQty));
  };

  const screenSize = useScreenSize();

  const handleClose = () => setModalShow(false);
  const handleCancel = () => {
    history.goBack();
  };

  return (
    <>
      <Header
        setQuery={setQuery}
        leftComponent={
          <div className="products-and-parts-header-content">
            <div
              className="products-and-parts-main-title  cursor-pointer"
              onClick={() => {
                history.push("/stock");
              }}
            >
              {/* Stock */}
              {FetchTranslationList[9]?.translation}
            </div>
            <p className="products-and-parts-sub-title">
              {/* Order Picking */}
              {FetchTranslationList[10]?.translation}
            </p>
          </div>
        }
      />
      {modalShow && (
        <CancelWarningModal
          show={modalShow}
          //   onHide={handleClose}
          backdrop="static"
          keyboard={false}
          //   handleCancel={handleCancel}
        />
      )}
      <RouteLeavingGuard
        when={typeField !== ""}
        navigate={(path) => history.push(path)}
        shouldBlockNavigation={(location) => {
          if (typeField !== "") {
            if (!["/stock"].includes(location.pathname)) {
              return true;
            }
          }
          return false;
        }}
      />

      <div className="ps-3">
        {(screenSize === "xs" || isOrderPicking) && (
          <div
            style={{
              display: "flex",
              // gap: "10px",
              // justifyContent: "space-between",
            }}
          >
            <div
              style={{ display: "flex", gap: "1px" }}
              onClick={() => {
                history.push("/stock");
              }}
            >
              <div
                style={{
                  color: "#7F7E7F",
                  fontWeight: "bolder",
                  fontSize: "1.1rem",
                  marginTop: "10px",
                  marginBottom: "15px",
                  paddingLeft: "20px",
                }}
              >
                {/* Stock */}
                {FetchTranslationList[9]?.translation}
              </div>
              <img
                alt=""
                src={Downarrow}
                style={{
                  opacity: "60%",
                  marginTop: "18px",
                  marginBottom: "15px",
                  width: "15px",
                  height: "12px",
                  transform: "rotate(90deg)",
                  cursor: "pointer",
                }}
              />
            </div>
            <div style={{ display: "flex", gap: "4px", marginRight: "20px" }}>
              <img
                alt=""
                src={OrderPickingIcon}
                style={{
                  opacity: "60%",
                  marginTop: "12px",
                  marginBottom: "15px",
                  width: "15px",
                  height: "24px",
                  transform: "rotate(0deg)",
                  cursor: "pointer",
                }}
              />
              <div
                style={{
                  color: "#7F7E7F",
                  fontWeight: "bolder",
                  fontSize: "1rem",
                  marginTop: "11px",
                  marginBottom: "15px",
                }}
              >
                {/* Order Picking */}
                {FetchTranslationList[10]?.translation}
              </div>
            </div>
          </div>
        )}
      </div>

      <div className="container-fluid">
        <div
          className={`${
            screenSize === "xs" || isOrderPicking
              ? "order-picking-content-mobile"
              : "order-picking-content"
          }`}
        >
          <div className="row">
            <div className="p-0 col-xl-8">
              <div
                className="list-Of-Field"
                style={{
                  position: "relative",
                  marginBottom: screenSize === "xs" || isOrderPicking ? "30px" : "50px",
                }}
                ref={projectDropRef}
              >
                {screenSize !== "xs" && !isOrderPicking && (
                  <div className="project-lable d-flex mb-3">
                    <img
                      alt=""
                      src={projectIconOrder}
                      className="project-form-icon"
                    />
                    <h5 className="project-lable-heading">
                      {/* Project */}
                      {FetchTranslationList[11]?.translation}
                    </h5>
                  </div>
                )}
                {(screenSize === "xs" || isOrderPicking) ? (
                  <div>
                    <div className="project-search-main-mobile">
                      <img
                        alt=""
                        className="search_pop ms-2 mb-1"
                        src={searchIcon}
                      />
                      <input
                        type="text"
                        value={searchItems}
                        style={{
                          margin: "0 0 0 0.5rem",
                          fontSie: "14px",
                        }}
                        // placeholder="Search"
                        placeholder={FetchTranslationList[24]?.translation}
                        className="search-style select-client-div"
                        onChange={(e) => {
                          setSearchItems(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="choose-project-dropdown">
                    <div
                      onClick={() => setShowClientDrop(!showClientDrop)}
                      className="project-drop-view d-flex"
                      style={{
                        justifyContent:
                          screenSize === "xs" || isOrderPicking
                            ? "flex-start"
                            : "space-between",
                      }}
                    >
                      <p className="margin-0-pop ordertype ps-2">
                        {/* {selectedProject || "Type a project "} */}
                        {selectedProject ||
                          FetchTranslationList[12]?.translation}
                      </p>

                      <BsChevronDown
                        size={18}
                        className={"down-arrow-pop bi-paperclip ms-4 ms-xxl-3"}
                      />
                    </div>

                    {showClientDrop && (
                      <div className="Outer-project-dropdown">
                        <div className="project-drop d-flex justify-content-between">
                          <p className="mb-2">
                            {/* Choose a Project */}
                            {FetchTranslationList[65]?.translation}
                          </p>
                          <BsChevronDown
                            size={18}
                            onClick={() => setShowClientDrop(!showClientDrop)}
                            className={"down-arrow-pop down-arrow-rotate"}
                          />
                        </div>

                        <div
                          className="project-search-main"
                          style={{ marginBottom: "10px" }}
                        >
                          <img
                            alt=""
                            className="search_pop ms-2 mb-1"
                            src={searchIcon}
                          />
                          <input
                            type="text"
                            value={projectSearch}
                            style={{
                              margin: "0 0 0 0.5rem",
                              fontSie: "14px",
                            }}
                            placeholder={FetchTranslationList[24]?.translation}
                            className="search-style select-client-div"
                            onChange={(e) => {
                              setProjectSearch(e.target.value);
                            }}
                          />
                        </div>
                        <div className="my-custom-scrollbar">
                          {projectTableData?.map((project) => {
                            return (
                              <p
                                key={project.projectid}
                                className="mb-1 ps-2 text-for-projects"
                                style={{
                                  textTransform: "capitalize",
                                  backgroundColor:
                                    selectedProject === project.projectname
                                      ? "#F4F5F4"
                                      : "transparent",
                                }}
                                onClick={() => {
                                  setsSelectedProject(project.projectname);
                                  setProjectId(project.projectid);
                                  setShowClientDrop(false);
                                  setTypeField("asc");
                                  setsSelectedProduct(null);
                                  setsSelectedQuote(null);
                                  setShowProductBottomList(false);
                                  dispatch({
                                    type: CREATE_ORDER_PICKING,
                                    data: {},
                                  });
                                  dispatch(
                                    FetchPOByProject(
                                      project.projectid,
                                      "Purchasing",
                                      // pageNumber,
                                      // itemsPerPage,
                                    ),
                                  );
                                  setCoverImage("");
                                  setProductTableData([]);
                                  setProductBottomTableData({});
                                  setProductId("");
                                }}
                              >
                                {project?.projectcode}&nbsp;┃&nbsp;
                                {project.projectname}
                              </p>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>

              {/* purchase order start */}
              <div
                className="list-Of-Field"
                style={{
                  position: "relative",
                  marginBottom: screenSize === "xs" || isOrderPicking ? "30px" : "50px",
                }}
                ref={purchaseOrderDropRef}
              >
                {screenSize !== "xs" && !isOrderPicking && (
                  <div className="project-lable d-flex mb-3">
                    <img
                      alt=""
                      src={projectIconOrder}
                      className="project-form-icon"
                    />
                    <h5 className="project-lable-heading">
                      Purchase Order
                      {/* {FetchTranslationList[11]?.translation} */}
                    </h5>
                  </div>
                )}
                {(screenSize === "xs" || isOrderPicking) ? (
                  <div>
                    <div className="project-search-main-mobile d-none">
                      <img
                        alt=""
                        className="search_pop ms-2 mb-1"
                        src={searchIcon}
                      />
                      <input
                        type="text"
                        value={searchItems}
                        style={{
                          margin: "0 0 0 0.5rem",
                          fontSie: "14px",
                        }}
                        // placeholder="Search"
                        placeholder={FetchTranslationList[24]?.translation}
                        className="search-style select-client-div"
                        onChange={(e) => {
                          setSearchItems(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="choose-project-dropdown">
                    <div
                      onClick={() =>
                        setShowPurchaseOrderDrop(!showPurchaseOrderDrop)
                      }
                      className="project-drop-view d-flex"
                      style={{
                        justifyContent:
                          screenSize === "xs" || isOrderPicking
                            ? "flex-start"
                            : "space-between",
                      }}
                    >
                      <p className="margin-0-pop ordertype ps-2">
                        {selectedPurchaseOrder || "Type a purchase order "}
                        {/* {selectedProject ||
                                   FetchTranslationList[12]?.translation} */}
                      </p>

                      <BsChevronDown
                        size={18}
                        className={"down-arrow-pop bi-paperclip ms-4 ms-xxl-3"}
                      />
                    </div>

                    {showPurchaseOrderDrop && (
                      <div className="Outer-project-dropdown">
                        <div className="project-drop d-flex justify-content-between">
                          <p className="mb-2">
                            Choose a Purchase Order
                            {/* {FetchTranslationList[65]?.translation} */}
                          </p>
                          <BsChevronDown
                            size={18}
                            onClick={() =>
                              setShowPurchaseOrderDrop(!showPurchaseOrderDrop)
                            }
                            className={"down-arrow-pop down-arrow-rotate"}
                          />
                        </div>

                        <div
                          className="project-search-main"
                          style={{ marginBottom: "10px" }}
                        >
                          <img
                            alt=""
                            className="search_pop ms-2 mb-1"
                            src={searchIcon}
                          />
                          <input
                            type="text"
                            value={purchaseOrderSearch}
                            style={{
                              margin: "0 0 0 0.5rem",
                              fontSie: "14px",
                            }}
                            placeholder={FetchTranslationList[24]?.translation}
                            className="search-style select-client-div"
                            onChange={(e) => {
                              setPurchaseOrderSearch(e.target.value);
                            }}
                          />
                        </div>
                        <div className="my-custom-scrollbar">
                          {purchaseOrderData?.map((poItem) => {
                            return (
                              <p
                                key={poItem.projectid}
                                className="mb-1 ps-2 text-for-projects"
                                style={{
                                  textTransform: "capitalize",
                                  backgroundColor:
                                    purchaseOrderId === poItem.orderid
                                      ? "#F4F5F4"
                                      : "transparent",
                                }}
                                onClick={() => {
                                  setSelectedPurchaseOrder(poItem.suppliername);
                                  setPurchaseOrderId(poItem.orderid);
                                  setPurchaseSupplierId(poItem.supplierid);
                                  setShowPurchaseOrderDrop(false);
                                  setTypeField("asc");
                                  // setsSelectedProduct(null);
                                  // setsSelectedQuote(null);
                                  // setShowProductBottomList(false);
                                  // dispatch({
                                  //   type: CREATE_ORDER_PICKING,
                                  //   data: {},
                                  // });
                                  // setCoverImage("");
                                  // setProductTableData([]);
                                  // setProductBottomTableData({});
                                  // setProductId("");
                                }}
                              >
                                {poItem?.ordercode}&nbsp;┃&nbsp;
                                {poItem.suppliername}
                              </p>
                            );
                          })}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
              {/* purchase order end */}

              <div
                className="list-Of-Field"
                style={{ position: "relative" }}
                ref={productDropRef}
              >
                {(screenSize === "xs" || isOrderPicking) ? (
                  <div className="project-lable d-flex mb-3">
                    <h5
                      className="project-lable-heading ms-0"
                      style={{ color: "#323232" }}
                    >
                      Choose From Purchase Order List
                      {/* {FetchTranslationList[14]?.translation} */}
                    </h5>
                  </div>
                ) : (
                  <div className="project-lable d-flex mb-3">
                    <img
                      alt=""
                      src={productIconOrder}
                      className="project-form-icon"
                    />
                    <h5 className="project-lable-heading">
                      {/* Product */}
                      {FetchTranslationList[30]?.translation}
                    </h5>
                  </div>
                )}
                {screenSize !== "xs" && !isOrderPicking && (
                  <div
                    className={
                      screenSize === "xs" || isOrderPicking
                        ? "choose-project-dropdown-mobile"
                        : "choose-project-dropdown"
                    }
                  >
                    <div
                      className={
                        screenSize === "xs" || isOrderPicking
                          ? "project-drop-view-mobile d-flex justify-content-between"
                          : "project-drop-view d-flex justify-content-between"
                      }
                    >
                      {screenSize !== "xs" && !isOrderPicking && (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                          }}
                          onClick={() => setShowProductDrop(!showProductDrop)}
                        >
                          <p className="margin-0-pop ordertype ps-2">
                            {/* {selectedProduct || "Type or scan an item"} */}
                            {selectedProduct ||
                              FetchTranslationList[14]?.translation}
                          </p>
                          <BsChevronDown
                            size={18}
                            className={
                              "down-arrow-pop bi-paperclip ms-4 ms-xxl-3"
                            }
                          />
                        </div>
                      )}
                    </div>

                    {showProductDrop && (
                      <div className="add-item-wrapper order-picking-wrapper">
                        <div className="d-flex justify-content-between align-items-center bgdiv">
                          <p className="inputparts px-3">Parts</p>
                          <div className="add-item-title w-100">
                            <input
                              className="update-member-input-noborder add-member-input bgforinput w-100"
                              value={searchItems}
                              onChange={(e) => {
                                setSearchItems(e.target.value);
                              }}
                              placeholder={
                                FetchTranslationList[24]?.translation
                              }
                            />
                          </div>
                          <img
                            src={DelIcon}
                            alt=""
                            className="mx-3 cursor-pointer"
                            onClick={() => setShowProductDrop(!showProductDrop)}
                          />
                        </div>
                        <div className="border-line d-none"></div>
                        <div className="stock-order-items-main gap-0 p-3">
                          {productTableData?.map((items, index) => (
                            <div key={index} className="w-100">
                              <div
                                className="missing-order-items add-item-title"
                                onClick={() => {
                                  handleSelectedProduct(items);
                                  setShowProductDrop(!showProductDrop);
                                  setShowProductDrop(false);
                                  setShowProductBottomList(true);
                                  setTypeField("asc");
                                }}
                              >
                                <div className="order-count-title">
                                  {items.productPartName}
                                </div>
                                {isBuildingBlock && (
                                  <div className="title-hover">
                                    <div className="items-desc-column4">
                                      <div className="desc-image-wrp4 desc-image4 ">
                                        {items?.cover ? (
                                          <>
                                            <div
                                              className={`product-list-image-default4 ${
                                                items?.image?.length === 0
                                                  ? "hover-hide4"
                                                  : ""
                                              }`}
                                            >
                                              <img
                                                src={items?.cover}
                                                alt=""
                                                className="cover-image4"
                                              />
                                              {items?.image &&
                                                items?.image?.length > 0 && (
                                                  <div className="image-row4">
                                                    {items?.image
                                                      .slice(0, 3)
                                                      .map((val, index) => (
                                                        <img
                                                          key={index}
                                                          src={val.image}
                                                          alt={`Images ${
                                                            index + 1
                                                          }`}
                                                        />
                                                      ))}
                                                  </div>
                                                )}
                                            </div>
                                            {items?.image &&
                                              items?.image?.length > 0 && (
                                                <span className="desc-image-plus4">
                                                  <Image
                                                    height={10}
                                                    width={10}
                                                    src={plusBorderWhite}
                                                  />
                                                </span>
                                              )}
                                          </>
                                        ) : (
                                          <div className="product-list-default4">
                                            <img
                                              src={Package}
                                              alt=""
                                              className="default-img4"
                                            />
                                            <div className="product-image-title4 d-none">
                                              Picture
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                )}
                                <div className="count-col">
                                  <div className="stock-order-col">
                                    {/* Stock */}
                                    {FetchTranslationList[9]?.translation}
                                  </div>
                                </div>

                                <div className="stock-items">
                                  <div className="d-flex align-items-center gap-3 justify-content-center">
                                    <div className="d-flex flex-column align-items-center justify-content-center gap-1">
                                      <div
                                        style={{
                                          backgroundColor: `${items.color}`,
                                        }}
                                        className="color-code"
                                      ></div>
                                    </div>

                                    <div className="info-items">
                                      {items.instock}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                )}
                {(screenSize === "xs" || isOrderPicking) && (
                  <div style={{ marginTop: "20px" }}>
                    <div
                      style={{
                        display: "flex",
                        borderBottom: "1px dotted #A5A5A5",
                        padding: "5px 0",
                      }}
                    >
                      <p
                        style={{
                          width: "30%",
                          color: "#707070",
                          marginBottom: "0",
                        }}
                      >
                        PO ID
                      </p>
                      <p
                        style={{
                          width: "70%",
                          color: "#707070",
                          marginBottom: "0",
                        }}
                      >
                        Supplier
                      </p>
                    </div>

                    {/* mobile */}
                    {projectTableData
                      ?.filter(
                        (x) =>
                          x.suppliername
                            ?.toLowerCase()
                            .includes(searchItems.toLowerCase()) ||
                          x.ordercode
                            ?.toLowerCase()
                            .includes(searchItems.toLowerCase()),
                      )
                      ?.map((item) => {
                        return (
                          <div
                            onClick={() => {
                              history.push("/order-picking-items-mobile", {
                                supplierid: item.supplierid,
                                suppliername: item.suppliername,
                                orderid: item.orderid,
                                //   projectId: item.projectid,
                                //   projectName: item.projectname,
                              });
                              handleSelectedProduct(item);
                              setTypeField("asc");
                            }}
                            style={{
                              display: "flex",
                              gap: "20px",
                              padding: "5px 0",
                              borderBottom: "1px dotted #A5A5A5",
                              alignItems: "center",
                            }}
                          >
                            <p
                              style={{
                                width: "30%",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                display: "block",
                                marginBottom: "0",
                              }}
                            >
                              {item?.ordercode}
                            </p>
                            <p
                              style={{
                                width: "70%",
                                wordWrap: "break-word",
                                overflow: "hidden",
                                marginBottom: "0",
                                color: "#323232",
                              }}
                            >
                              {item?.suppliername}
                            </p>
                            <img
                              alt=""
                              src={Downarrow}
                              style={{
                                opacity: "60%",
                                width: "18px",
                                height: "12px",
                                transform: "rotate(-90deg)",
                                cursor: "pointer",
                                color: "#333333",
                              }}
                            />
                          </div>
                        );
                      })}
                  </div>
                )}
              </div>

              {screenSize !== "xs" && !isOrderPicking && (
                <div className="product-list-Field">
                  <div className="d-flex flex-wrap gap-3 items-row">
                    <div className="order-table-th col-md-2">
                      <h3 className="order-table-heading">
                        {/* Item ID */}
                        {FetchTranslationList[17]?.translation}
                      </h3>
                      <div className="order-table-td">
                        <div className="order-table-output">
                          {productBottomTableData?.productPartCode}
                        </div>
                      </div>
                    </div>
                    <div className="order-table-th col-md-3 d-none">
                      <h3 className="order-table-heading">
                        {/* Supplier Code */}
                        {FetchTranslationList[18]?.translation}
                      </h3>
                      <div className="order-table-td">
                        <div className="order-table-output">
                          {productBottomTableData?.productPartCode}
                        </div>
                      </div>
                    </div>
                    <div className="order-table-th col-md-2">
                      <h3 className="order-table-heading">
                        Kg
                        {/* {FetchTranslationList[19]?.translation} */}
                      </h3>
                      <div className="order-table-td">
                        <div className="order-table-output">
                          {productBottomTableData?.kg}
                        </div>
                      </div>
                    </div>
                    <div className="order-table-th col-md-2">
                      <h3 className="order-table-heading">
                        {/* In Stock */}
                        {FetchTranslationList[20]?.translation}
                      </h3>
                      <div className="order-table-td">
                        <div className="order-table-output">
                          {productBottomTableData?.instock}
                        </div>
                      </div>
                    </div>

                    <div className="col-2"></div>

                    <div className="order-table-th col-md-2 ms-1">
                      <h3 className="order-table-heading">
                        {/* Qty to Pick */}
                        {FetchTranslationList[21]?.translation}
                      </h3>
                      <div className="d-flex justify-content-center">
                        <div className="order-table-output pt-0">
                          <input
                            value={
                              productBottomTableData?.newQtyToPick ??
                              productBottomTableData?.qtyToPick ??
                              0
                            }
                            min="0"
                            type="number"
                            onChange={(e) => handleInputChange(e)}
                            style={{
                              border: "none",
                              height: "inherit",
                              width: "100%",
                              textAlign: "center",
                            }}
                          />
                        </div>
                      </div>
                      {productBottomTableData?.newQtyToPick >
                      productBottomTableData?.instock ? (
                        <span style={{ color: "red" }}>
                          Qty can't exceed stock
                        </span>
                      ) : productBottomTableData?.newQtyToPick >
                        productBottomTableData?.instock ? (
                        <span style={{ color: "red" }}>
                          You cannot pick item above the qtyToPick
                        </span>
                      ) : null}
                    </div>
                  </div>
                </div>
              )}
            </div>
            {/* quote */}
            {screenSize !== "xs" && !isOrderPicking && (
              <div className="pe-0 col-xl-4">
                <div
                  className="list-Of-Field"
                  style={{ position: "relative" }}
                  ref={quoteDropRef}
                >
                  <div className="project-lable d-flex mb-3">
                    <img
                      src={quoteIconOrder}
                      className="project-form-icon"
                      alt=""
                    />
                    <h5 className="project-lable-heading">
                      {/* Quote */}
                      {FetchTranslationList[15]?.translation}
                    </h5>
                  </div>
                  <div className="choose-project-dropdown pointerEvent">
                    <div
                      onClick={() => setShowQuoteDrop(!showQuoteDrop)}
                      className="project-drop-view d-flex justify-content-between"
                    >
                      <p className="margin-0-pop ordertype ps-2">
                        {/* {selectedQuote || "Choose a quote"} */}
                        {selectedQuote || FetchTranslationList[16]?.translation}
                      </p>
                      <BsChevronDown
                        size={18}
                        className={"down-arrow-pop bi-paperclip ms-4 ms-xxl-3"}
                      />
                    </div>

                    {showQuoteDrop && (
                      <div className="Outer-project-dropdown">
                        <div className="project-drop d-flex justify-content-between">
                          <p className="mb-2">
                            {/* Select Quote */}
                            {FetchTranslationList[55]?.translation}
                          </p>
                          <BsChevronDown
                            size={18}
                            onClick={() => setShowQuoteDrop(!showQuoteDrop)}
                            className={"down-arrow-pop down-arrow-rotate"}
                          />
                        </div>
                        <div className="my-custom-scrollbar">
                          <p
                            className="mb-1 text-for-projects"
                            style={{
                              textTransform: "capitalize",
                              backgroundColor:
                                selectedQuote === "22-00899-5"
                                  ? "#F4F5F4"
                                  : "transparent",
                            }}
                            onClick={() => {
                              setsSelectedQuote("22-00899-5");
                              setShowQuoteDrop(false);
                              setTypeField("asc");
                            }}
                          >
                            22-00899-5
                          </p>
                          <p
                            className="mb-1 text-for-projects"
                            style={{
                              textTransform: "capitalize",
                              backgroundColor:
                                selectedQuote === "22-00899-4"
                                  ? "#F4F5F4"
                                  : "transparent",
                            }}
                            onClick={() => {
                              setsSelectedQuote("22-00899-4");
                              setShowQuoteDrop(false);
                              setTypeField("asc");
                            }}
                          >
                            22-00899-4
                          </p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {isBuildingBlock && (
                  <div className="list-Of-Field order-pickingimagehide">
                    <div className="project-lable d-flex mb-3">
                      <h5 className="project-lable-heading">
                        {/* Product Image */}
                        {FetchTranslationList[29]?.translation}
                      </h5>
                    </div>
                    <div className="product-order-images">
                      {coverImage && <img src={coverImage} alt="" />}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderPickingPOMobile;
